import { selector } from 'recoil';
import useHttpRequest from '../../components/api/HttpRequest';

const ConsumablesConfigSelector = selector({
  key: 'consumablesConfigSelector',
  get: async () => {
    try {
      const httpRequest = useHttpRequest();
      const result = await httpRequest.send('/config?filter=consumables');
      // eslint-disable-next-line no-console
      console.log('consumables config result', result);
      return result;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Error fetching consumables config', err);
      return {};
    }
  },
});

export default ConsumablesConfigSelector;
